const DEFAULT_TOP_RECORDS_LENGTH = 5;
export default ((recordSizes, top = DEFAULT_TOP_RECORDS_LENGTH) => {
  const topRecords = Array.from(recordSizes.entries()).sort((recordSizeA, recordSizeB) => recordSizeB[1] - recordSizeA[1]).slice(0, top).map(record => `${record[0]} : (${record[1]}b)`);
  return `Top Records:\n${topRecords.join(`\n`)}`;
});